import { Environment, Language, PcidAuth } from '@pcid/web-sdk';

// ============================================================
// TODO: REMOVE AFTER TESTING - Custom token expiry for testing
// Sets access token to expire in 3 minutes instead of default
// Reference: https://docs.oracle.com/en/cloud/paas/identity-cloud/idcsa/customexpiry.html
// ============================================================
const ENABLE_SHORT_TOKEN_EXPIRY = process.env.NEXT_PUBLIC_ENABLE_SHORT_TOKEN_EXPIRY === 'true';
const TEST_TOKEN_EXPIRY_SECONDS = 180; // 3 minutes

const baseScope = process.env.NEXT_PUBLIC_PCID_SCOPE || '';
const testExpiryScope = `urn:opc:resource:expiry=${TEST_TOKEN_EXPIRY_SECONDS}`;
const scope = ENABLE_SHORT_TOKEN_EXPIRY ? `${baseScope} ${testExpiryScope}` : baseScope;
// ============================================================

export const pcidConfig = {
  clientId: process.env.NEXT_PUBLIC_PCID_CLIENT_ID || '',
  clientSecret: process.env.NEXT_PUBLIC_PCID_CLIENT_SECRET || '',
  scope,
  addOfflineAccessToScopes: true,
  stateParams: {
    relyingParty: 'sdm',
    intent: 'login',
    language: Language.EN,
    customProps: {
      name: 'sdm-frontshop',
    },
  },
  redirectUrl: process.env.NEXT_PUBLIC_PCID_REDIRECT_URL || '',
  environment: process.env.NEXT_PUBLIC_APP_ENV === 'prod' ? Environment.PRODUCTION : Environment.LOWER,
  keepMeSignedIn: true,
  showIsThisYouPrompt: true,
  pkceFlow: true,
};

export const pcidAuth = new PcidAuth(pcidConfig);
